<template>
<!-- 意见反馈 -->
    <div>
        <el-form :model="listQuery" :inline="true" class="form-box" size="small">
            <div>
                 <el-form-item label="反馈类型：">
                    <el-select v-model="listQuery.opinionType" style="width:200px" clearable>
                        <el-option v-for="(item,index) in feedbackList" :key="index" 
                        :value="item.name" 
                        :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="反馈时间：">
                    <el-date-picker
                    @change="timeChange"
                    v-model="listQuery.value"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-input v-model.trim="listQuery.keyword" style="width:220px" placeholder="请输入评论人"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search">搜索</el-button>
                    <el-button type="" @click="reset">重置</el-button>
                </el-form-item>
            </div>
            <diV>
                <el-button type="" @click="upload" icon="el-icon-download" size="small">下载</el-button>
            </diV>
        </el-form>
        <el-table 
        :header-cell-style="{ fontWeight: 400,background:'#F0F5FC',color:'#333333'}"
        :data="tableData" border style="width: 100%">
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <el-table-column prop="userName" label="反馈人" width="170"></el-table-column>
            <el-table-column prop="userPhone" label="联系电话"></el-table-column>
            <el-table-column prop="createTime" label="反馈时间" width="" ></el-table-column>
            <el-table-column prop="opinionType" label="反馈类型">
                <template v-slot="scope">
                    <span>{{ scope.row.opinionType | typeFilters}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="opinionText" label="反馈内容"></el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                    <el-tooltip class="item pointer" effect="dark" content="查看" placement="top">
                        <img src="@/assets/tableIcon/view.png" @click="viewData(scope.row)" />
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <div class="page-box" v-if="total>=10">
            <el-pagination
                background
                @current-change="currentChange"
                :current-page.sync="listQuery.page"
                :page-size="listQuery.size"
                layout="total, prev, pager, next, jumper"
                :total="total"
            >
             </el-pagination>
        </div>
        <el-dialog
            title="意见反馈"
            :close-on-click-modal="false"
            :visible.sync="dialogVisible"
            width="600px">
            
            <el-descriptions title="" :column="1">
                <el-descriptions-item label="反馈类型">{{ form.opinionType | typeFilters }}</el-descriptions-item>
                <el-descriptions-item label="反馈内容">{{ form.opinionText }}</el-descriptions-item>
                <el-descriptions-item label="图片">
                    <div v-for="(item,index) in imgList" :key="index">
                        <img :src="item" style="width: 100px;height: 100px;" />
                    </div>
                </el-descriptions-item>
            </el-descriptions>
        </el-dialog>
    </div>
</template>

<script>
// import { selectListShitang } from "@/api/screenShow";
// import {evaluatePage,commentexport} from "@/api/configure.js";
// import {mealpage} from "@/api/mealFarewell";
import {getOpinion,fileDownLoad} from "@/api/systemManagement"
    export default {
        data() {
            return {
                dialogVisible: false,
                listQuery:{
                    current:1,
                    size:10,
                    keyword:"",
                    opinionType: "",
                    value:[],
                },
                form: {},
                total:0,
                tableData:[],
                feedbackList: [
                    {name:'菜品质量',value:1},
                    {name:'价格满意度',value:2},
                    {name:'功能异常',value:3},
                    {name:'其他',value:4},
                ],
                imgList: [],
            }
        },
        filters: {
            typeFilters(val) {
                if(val==1) {
                    return '菜品质量'
                } else if(val==2) {
                    return '价格满意度'
                } else if(val==3) {
                    return '功能异常'
                } else if(val==4) {
                    return '其他'
                }else {
                    return '--'
                }
            }
        },
        mounted() {
            // this.renderContent()
            // this.getmealList()
            this.getTableList()
        },
        methods:{
            timeChange(val) {
                if(val) {
                    this.listQuery.startTime = val[0] + " 00:00:00" || "";
                    this.listQuery.endTime = val[1] + " 23:59:59" || ""
                } else {
                    this.listQuery.startTime = "";
                    this.listQuery.endTime = "";
                    this.listQuery.value = []
                }
            },
            search() {
                this.listQuery.current = 1;
                this.getTableList()
            },
            reset() {
                this.listQuery = {
                    current:1,
                    size:10,
                    value:[],
                    startTime:"",
                    endTime:"",
                }
                this.getTableList()
            },
            currentChange(val) {
                this.listQuery.current = val;
                this.getTableList()
            },
            getTableList() {
                let data = {
                    ...this.listQuery,
                }
                getOpinion(data).then(res=>{
                    if(res.code==1) {
                        this.tableData = res.data.records || [];
                        this.total = res.data.total
                    }
                })
            },
            viewData(row) {
                this.form = {...row};
                this.imgList = this.form.fileUrl.split(",");
                for (let i = 0; i < this.imgList.length; i++) {
                    fileDownLoad({ filePath: dataList[i] }).then((res) => {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        dataList[i] = e.target.result;
                    };
                    reader.readAsDataURL(res.data);
                    });
                }
                this.dialogVisible = true
            },
            upload() {
                let fileName = "评论数据表.xls";
                commentexport({...this.listQuery}).then(res=>{
                    if (window.navigator.msSaveOrOpenBlob) {
                        // 兼容IE10
                        navigator.msSaveBlob(res.data, fileName);
                    } else {
                        let aTag = document.createElement("a");
                        aTag.download = fileName;
                        aTag.href = URL.createObjectURL(res.data);
                        aTag.click();
                        URL.revokeObjectURL(aTag.href);
                    }
                })
            }
        }
    }
</script>

<style lang="less" scoped>
.form-box {
    display: flex;
    justify-content: space-between;
}
</style>